<template>
<div
  class="flex-none overflow-hidden flex justify-end items-center h-10 rounded-full border border-transparent bg-grey-lighter ease-in-300"
  :class="{
    'bg-white border-grey': extended
  }"
>
  <input
    ref="searchInput"
    placeholder="suchen"
    :value="value"
    @input="$emit('input', $event.target.value)"
    @blur="collapse"
    type="text"
    name="search"
    class="mx-3 my-2 ease-in-300 visible w-48 w-full focus:outline-none"
    :class="{
      'not-visible': !extended
    }"
  >
  <button class="m-0 p-0 focus:outline-none flex-none w-6 h-6 mx-2" @click="buttonAction">
  <img
    v-if="!value"
    src="/static/icons/search.svg"
    title="suchen"
    alt="Suche"
  />
  <img
    v-else
    src="/static/icons/delete.svg"
    title="Eingabe löschen"
    alt="löschen"
  />
  </button>
</div>
</template>

<script>
export default {
  name: 'HostSearch',
  props: {
    value: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      extended: false,
      alwaysExtended: false
    }
  },

  created () {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (width > 900) {
      this.extended = true
      this.alwaysExtended = true
    }
  },

  methods: {
    buttonAction () {
      if (this.extended && this.value) {
        this.$emit('input', '')
        this.$refs.searchInput.focus()
      } else if (!this.extended) {
        this.extended = !this.extended
        setTimeout(() => {
          this.$refs.searchInput.focus()
        }, 400)
      }
    },

    collapse () {
      if (this.alwaysExtended) return
      if (!this.value) this.extended = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .ease-in-300{
    transition: all .3s ease-in;
  }

  .not-visible{
    width: 0;
    visibility: hidden;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/HostSearch.vue